import * as api from '../../apis/products';
import { apiCall } from '~/lib/redux/api';
import { EntityActions } from '~/apps/shared/actions/consts';
import { ProductsActions } from './consts';
import { ProductNormalizer } from './normalize';
import { defaultTablePageSize } from '~/common/components/consts';


export function getOrgProducts(orgId: number, q: string | null = null, offset=0, limit=defaultTablePageSize) {
  return apiCall({
    actions: [
      ProductsActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, ProductsActions.LOAD_LIST_SUCCESS],
      ProductsActions.LOAD_ERROR,
    ],
    normalizer: [ProductNormalizer],
    fn: () => api.getOrgProducts(orgId, offset, limit),
  })
}

export function getLocationProducts(locationId: string, q: string | null = null, offset = 0, limit = 0) {
  return apiCall({
    actions: [
      ProductsActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, ProductsActions.LOAD_LIST_SUCCESS],
      ProductsActions.LOAD_ERROR,
    ],
    normalizer: [ProductNormalizer],
    fn: () => api.getLocationProducts(locationId, offset, limit),
  });
}

export function setProductsPage(page: number) {
  return {
    type: ProductsActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
